import Container from "@ui/container";
import React from "react";

const Line = () => <div className="w-full border-t border-skin-divider"></div>;

const Seperator = ({ data }) => {
    return data && data.isFullWidth ? (
        <Line />
    ) : (
        <Container>
            <Line />
        </Container>
    );
};

export default Seperator;
